import { keepPreviousData, useQuery } from '@tanstack/react-query';

import {
  partnersCampaignsApi,
  partnersCampaignsApiKeys,
  type CampaignLeadsParams,
} from '@/api/routes/partners/partners.campaigns.api';

/**
 * Contacts of users who accepted to share them. Reading them marks them delivered in the
 * API, so the query only runs for campaigns whose offer collects contacts (`enabled`).
 */
export const usePartnersReadCampaignLeads = (
  id: string | undefined,
  params: CampaignLeadsParams,
  enabled = true,
) => {
  return useQuery({
    queryKey: partnersCampaignsApiKeys.leads(id ?? '', params),
    queryFn: () => partnersCampaignsApi.leads(id as string, params).then((res) => res.data),
    enabled: Boolean(id) && enabled,
    placeholderData: keepPreviousData,
  });
};
